import React from "react";
import {ResponsiveView} from "../../../components/index.jsx";
import {Devices} from "../../../components/ResponsiveView/consts.js";
import {TableDateSearchProvider} from "../../../admin/Context/TableDateSearchContext.jsx";
import {CompanyBriefs} from "./CompanyBriefs.jsx";

export const CompanyBriefsWrapper = () => {
    return (
        <TableDateSearchProvider localStorageKey="companyBriefsSearchDate">
            <ResponsiveView devices={[Devices.desktop, Devices.mobile]}>
                <CompanyBriefs />
            </ResponsiveView>
        </TableDateSearchProvider>
    );
};
